import 'css-chunksrc/client/scenes/unavailabilityCreation/unavailabilityCreationForm/styles.scss';export default {
  "unavailabilityCreationForm": "_unavailabilityCreationForm_2a8oo_1",
  "group": "_group_2a8oo_8",
  "title": "_title_2a8oo_12",
  "dateGroup": "_dateGroup_2a8oo_17",
  "selectInput": "_selectInput_2a8oo_27",
  "reasonSelectInput": "_reasonSelectInput_2a8oo_43",
  "inputOpen": "_inputOpen_2a8oo_58",
  "invalidSelectInput": "_invalidSelectInput_2a8oo_62",
  "arrowIcon": "_arrowIcon_2a8oo_66",
  "arrowIconClose": "_arrowIconClose_2a8oo_76",
  "arrowIconOpen": "_arrowIconOpen_2a8oo_80",
  "avatar": "_avatar_2a8oo_84",
  "dateTimeInput": "_dateTimeInput_2a8oo_92",
  "reasonRow": "_reasonRow_2a8oo_97",
  "row": "_row_2a8oo_101",
  "hoursGroup": "_hoursGroup_2a8oo_111",
  "listSelect": "_listSelect_2a8oo_120",
  "list": "_list_2a8oo_120",
  "pagedList": "_pagedList_2a8oo_136",
  "listItem": "_listItem_2a8oo_142",
  "itemName": "_itemName_2a8oo_156",
  "selectedItem": "_selectedItem_2a8oo_161",
  "checkbox": "_checkbox_2a8oo_165",
  "label": "_label_2a8oo_174"
};